import React, { createContext, useContext, useState } from 'react';

const ColorModeContext = createContext();
export const useColorMode = () => useContext(ColorModeContext);

const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState('light');

  const toggleColorMode = () => {
    setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
  };

  return (
    <ColorModeContext.Provider value={{ mode, toggleColorMode, setMode }}>
      {children}
    </ColorModeContext.Provider>
  );
};

export default ColorModeProvider;
